module.exports = __webpack_public_path__ + "static/media/banner_parkrunTest.6114fb14.png";